import { Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import Reveal, { stagger, fadeUp } from "@/components/motion/Reveal";

export default function WhyChoose() {
  const { t } = useI18n();
  const w = t.whyChoose;
  return (
    <section data-testid="why-choose-section" className="section-pad bg-surface-dark text-white relative overflow-hidden">
      <div className="absolute inset-0 dot-bg opacity-40" aria-hidden />
      <div className="absolute inset-0 noise-overlay pointer-events-none" aria-hidden />
      <div className="container-pro relative grid md:grid-cols-12 gap-10 items-start">
        <Reveal className="md:col-span-5">
          <div className="overline">{w.kicker}</div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight text-white">
            {w.title1}
            <br />
            <span className="text-brand-red">{w.title2}</span>
          </h2>
          <p className="mt-6 text-white/60 max-w-md">{w.body}</p>
          <a href="#contact" className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-white border-b border-brand-red pb-1 hover:text-brand-red transition-colors" data-testid="why-choose-cta">
            {w.cta}
          </a>
        </Reveal>

        <Reveal variants={stagger(0.08, 0.1)} className="md:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
          {w.reasons.map((r, i) => (
            <Reveal key={i} variants={fadeUp} data-testid="why-choose-item" className="group bg-surface-dark p-7 transition-colors hover:bg-white/[0.04]">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-brand-red text-white transition-transform duration-300 group-hover:scale-110">
                <Check size={16} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-semibold text-white">{r.title}</h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">{r.body}</p>
            </Reveal>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
